import * as Sentry from "@sentry/astro";

Sentry.init({
  dsn: "https://884616dbefce74b43dd804bfa43ff4ba@o4508213602615296.ingest.us.sentry.io/4508684496076800",
  debug: false,
  environment: "production",
  release: "20f0258097b0e9ffa20d5675a5ea00341cdbc864",
  tracesSampleRate: 1,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1,
});
import { init } from 'astro/virtual-modules/prefetch.js';init()